module.exports = __webpack_public_path__ + "static/media/majorC7.cd09583.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/sing/majorC7.wav
// module id = R4lq
// module chunks = 0